<div class="d-flex h-100 apoteca-fake-container">
    <div class="apoteca-fake-header container-fluid">
        <mat-icon class="mr-1">notifications_none</mat-icon>
        <mat-icon>person</mat-icon>
    </div>
    <div class="left-content"></div>
    <div class="flex-grow-1">
        <ng-content></ng-content>
    </div>
</div>